import { GetterTree } from 'vuex';

import {
  PaymentStateI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<PaymentStateI, RootStateI> = {
};
